import React from 'react';
import Styles from './Misrow.module.css';

const Misrow = () => {
  return (
    <div className={Styles.misrowContainer}>

      {/* Hero Section */}
      <div className={Styles.hero} style={{backgroundImage: `url(${'/heroSectionBanner.jpg'})`}}>
        <div className={Styles.container}>

          <div className={Styles.heroContent}>
            <h1 className={Styles.heroTitle}>
              MISROW  
            </h1>
            <span className={Styles.gradientText}>Connecting Businesses to the Digital Economy</span>
            <p className={Styles.heroSubtitle}>
              Helping businesses participate in India's rapidly expanding digital economy.
            </p>

            {/* <div className={Styles.heroBadge}>✨ India's Growing Digital Marketplace</div> */}

            <div className={Styles.buttonGroup}>
              <button className={`${Styles.btn} ${Styles.btnPrimary}`} onClick={()=>{ window.open("https://misrow.com/", "_blank");}}>
                Visit Misrow <span className={Styles.btnArrow}>→</span>
              </button>
              <button className={`${Styles.btn} ${Styles.btnOutline}`} >
                Become a Seller <span className={Styles.btnArrow}>→</span>
              </button>
            </div>
            <div className={Styles.heroStats}>
              <div className={Styles.statItem}>
                <span className={Styles.statNumber}>500+</span>
                <span className={Styles.statLabel}>Active Sellers</span>
              </div>
              <div className={Styles.statDivider}></div>
              <div className={Styles.statItem}>
                <span className={Styles.statNumber}>50K+</span>
                <span className={Styles.statLabel}>Happy Customers</span>
              </div>
              <div className={Styles.statDivider}></div>
              <div className={Styles.statItem}>
                <span className={Styles.statNumber}>100+</span>
                <span className={Styles.statLabel}>Cities Covered</span>
              </div>
            </div>
          </div>         

        </div>
      </div>

      
      {/* Overview Section */}
      <section className={Styles.overview}>
        <div className={Styles.container}>
          <div className={Styles.overviewGrid}>

            <div className={Styles.overviewContent}>
              <span className={Styles.sectionBadge}>Who We Are</span>
              <h2 className={Styles.sectionTitle}>Powering Digital Commerce Across India</h2>
              <p className={Styles.overviewText}>
                MISROW is a multi-vendor e-commerce marketplace developed by <strong>ICOESS Solutions</strong>. 
                The platform is designed to help businesses, retailers and entrepreneurs establish their 
                digital presence, reach more customers, and grow their sales through a unified online marketplace.
              </p>
             
              <div className={Styles.overviewFeatures}>
                <div className={Styles.overviewFeature}>
                  <span className={Styles.checkIcon}>✓</span> Zero Commission on First 3 Months
                </div>
                <div className={Styles.overviewFeature}>
                  <span className={Styles.checkIcon}>✓</span> Free Seller Training & Support
                </div>
                <div className={Styles.overviewFeature}>
                  <span className={Styles.checkIcon}>✓</span> Pan India Shipping Network
                </div>
              </div>
            </div>

        

            <div className={Styles.overviewImageContainer}>
              <img src="/PowerIndiaEcom.jpg" alt="" />
            </div>

          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className={Styles.vision}>
        <div className={Styles.container}>
          <div className={Styles.visionCard}>

             <div className={Styles.visonimage}>
              <img src="/ourVision.jpg" alt="" />
            </div>

            <div className={Styles.visonInfo}>
                <h2 className={Styles.visionTitle}> Our Vision</h2>
                <p className={Styles.visionText}>
                  MISROW aims to support local businesses, small sellers, and entrepreneurs by providing 
                  access to digital commerce opportunities, enabling them to grow across India and global 
                  markets through a modern multi-vendor marketplace.
                </p>
            </div>

          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className={Styles.features}>
        <div className={Styles.container}>
          <div className={Styles.sectionHeader}>
            <span className={Styles.sectionBadge}>Platform Capabilities</span>
            <h2 className={Styles.sectionTitle}>Everything You Need to Scale</h2>
            <p className={Styles.sectionSubtitle}>Powerful tools to manage, grow, and optimize your online business</p>
          </div>
          <div className={Styles.featuresGrid}>

              <div className={Styles.featureCard}>
                <div className={Styles.featureIconWrapper}>
                 <img src="/MultiVendorMarketplace.jpg" alt="" />
                </div>
                <div className={Styles.featureWrapper}>
                  <h3>Multi-Vendor Marketplace</h3>
                  <p>Empower multiple sellers on a single unified platform with dedicated tools.</p>
                  <ul>
                    <li>Dedicated seller dashboards</li>
                    <li>Product & inventory management</li>
                    <li>Order processing & fulfillment</li>
                  </ul>
                </div>
              </div>
              <div className={Styles.featureCard}>
                <div className={Styles.featureIconWrapper}>
                  <img src="/sequerty.jpg" alt="" />
                </div>
                <div className={Styles.featureWrapper}>
                  <h3>Secure Payments</h3>
                  <p>Enterprise-grade payment security with automated settlements.</p>
                  <ul>
                    <li>Online payment collection</li>
                    <li>Secure transaction processing</li>
                    <li>Automated seller settlements</li>
                    <li>Refund management</li>
                  </ul>
                </div>
              </div>
              <div className={Styles.featureCard}>
                <div className={Styles.featureIconWrapper}>
                  <img src="/logistic.jpg" alt="" />
                </div>
                <div className={Styles.featureWrapper}>
                   <h3>Logistics Integration</h3>
                  <p>Seamless shipping with top courier partners across India & globally.</p>
                  <ul>
                    <li>Real-time shipment tracking</li>
                    <li>Courier partner integration</li>
                    <li>Domestic & international shipping</li>
                    <li>Automated shipping labels</li>
                  </ul>
                </div>
               
              </div>
              <div className={Styles.featureCard}>
                <div className={Styles.featureIconWrapper}>
                  <img src="/SellerGrowthTools.jpg" alt="" />
                </div>
                <div className={Styles.featureWrapper}>
                  <h3>Seller Growth Tools</h3>
                  <p>Advanced marketing and analytics to boost your sales.</p>
                  <ul>
                    <li>Premium business listings</li>
                    <li>Promotional campaigns</li>
                    <li>Marketing support</li>
                    <li>Performance analytics</li>
                  </ul>
                </div>
              </div>

          </div>
        </div>
      </section>

      {/* Who Can Sell Section */}
      <section className={Styles.sellers}>
        <div className={Styles.container}>
          <div className={Styles.sectionHeader}>
            <span className={Styles.sectionBadge}>Join the Marketplace</span>
            <h2 className={Styles.sectionTitle}>Who Can Sell on MISROW?</h2>
            <p className={Styles.sectionSubtitle}>Built for businesses of all sizes — from local shops to growing brands</p>
          </div>
          <div className={Styles.sellerCategories}>
            {[
              { icon: "🛍️", name: "Retail Stores" },
              { icon: "👗", name: "Fashion & Apparel" },
              { icon: "📱", name: "Electronics" },
              { icon: "🏠", name: "Home & Living" },
              { icon: "🎨", name: "Handmade Products" },
              { icon: "🥬", name: "Grocery & Daily Needs" },
              { icon: "🏭", name: "Local Manufacturers" },
              { icon: "🏢", name: "SMEs" },
              { icon: "🚀", name: "Startups" }
            ].map((category, index) => (
              <div key={index} className={Styles.sellerCard}>
                <span className={Styles.sellerIcon}>{category.icon}</span>
                <span>{category.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className={Styles.benefits}>
        <div className={Styles.container}>
          <div className={Styles.sectionHeader}>
            <span className={Styles.sectionBadge}>Why Choose Us</span>
            <h2 className={Styles.sectionTitle}>Benefits for Sellers</h2>
            <p className={Styles.sectionSubtitle}>Start selling online with zero setup cost and grow your business</p>
          </div>
          <div className={Styles.benefitsGrid}>

            <div className={Styles.benefitCard}>
              <img src="/expandMarketRearch.jpg" alt="" />
              <h3>Expand Market Reach</h3>
              <p>Sell to customers beyond your local area and access pan-India audience</p>
              <div className={Styles.benefitLink}>Learn more →</div>
            </div>

            <div className={Styles.benefitCard}>
              {/* <div className={Styles.benefitIcon}>💰</div> */}
              <img src="/noCostSetup.jpg" alt="" />
              <h3>No Setup Cost</h3>
              <p>Start selling online without building your own e-commerce website</p>
              <div className={Styles.benefitLink}>Get started →</div>
            </div>
            <div className={Styles.benefitCard}>
              {/* <div className={Styles.benefitIcon}>⚙️</div> */}
              <img src="/simplifiedImage.jpg" alt="" />
              <h3>Simplified Operations</h3>
              <p>Manage products, orders, inventory, and payments from one dashboard</p>
              <div className={Styles.benefitLink}>Explore tools →</div>
            </div>
            <div className={Styles.benefitCard}>
              {/* <div className={Styles.benefitIcon}>🚀</div> */}
              <img src="/BusinessGrowthSupport.jpg" alt="" />
              <h3>Business Growth Support</h3>
              <p>Access marketing, promotional, and branding opportunities</p>
              <div className={Styles.benefitLink}>View plans →</div>
            </div>

          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className={Styles.cta}>
        <div className={Styles.container}>
          <div className={Styles.ctaCard}>
            <h2>Ready to Start Your E-commerce Journey?</h2>
            <p>Join thousands of sellers who are growing their business with MISROW</p>
            <div className={Styles.ctaButtons}>
              <button className={`${Styles.btn} ${Styles.btnPrimary}`} onClick={()=>{ window.open("https://misrow.com/", "_blank");}}>Become a Seller →</button>
              {/* <button className={`${Styles.btn} ${Styles.btnOutlineWhite}`}>Schedule a Demo →</button> */}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Misrow;






